export enum ProcessingMessage {
  DEFAULT = 'Current process is in progress',
  AGREEMENT = 'Purchase Agreement is generating',
  REDIRECT = 'Waiting for redirect',
}
